"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryVoiceResponseModelCategory = void 0;
exports.LibraryVoiceResponseModelCategory = {
    Generated: "generated",
    Cloned: "cloned",
    Premade: "premade",
    Professional: "professional",
    Famous: "famous",
    HighQuality: "high_quality",
};
